import { Fragment } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useCheckoutTabContext } from "../CheckoutTabContext";
import { BuilderSidebar } from "../components/BuilderSidebar";
import { PROPERTIES, localeRoot } from "../constants";
import { DefaultProperties } from "./Properties/DefaultProperties";
import { TestimonialProperties } from "./Properties/TestimonialProperties";
import { Header } from "./components/Header";

export const Sidebar = () => {
  const { goBack, history, currentSidebar } = useCheckoutTabContext();

  const sidebarContentMapping = {
    [PROPERTIES.DEFAULT]: [
      DefaultProperties,
      t([localeRoot, "builder.default.title"]),
    ],
    [PROPERTIES.TESTIMONIALS]: [
      TestimonialProperties,
      t([localeRoot, "builder.testimonials.title"]),
    ],
  };

  const [SidebarContent, title] = sidebarContentMapping[currentSidebar] || [
    Fragment,
    "",
  ];

  return (
    <BuilderSidebar className="flex w-[328px] flex-col">
      <Header className="gap-x-3.5">
        {history.length > 1 && (
          <Button onClick={goBack} variant="circle-text" className="text-dark">
            <Icon type="24-arrow-left" />
          </Button>
        )}
        <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
      </Header>
      <SidebarContent />
    </BuilderSidebar>
  );
};
